import React from "react";

export interface SelectOption {
  label: string;
  value: string;
}

interface SingleSelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
}

const SingleSelect: React.FC<SingleSelectProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="w-full">
      <select
        value={value}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onChange(e.target.value)
        }
        className="
          w-full
          rounded-md
          border
          border-gray-300
          bg-white
          px-3
          py-2
          text-sm
          shadow-sm
          focus:border-blue-500
          focus:outline-none
          focus:ring-1
          focus:ring-blue-500
          dark:bg-slate-700
          dark:border-slate-600
          dark:text-white
          dark:focus:ring-blue-500
        "
      >
        <option value="" disabled>
          Select Collection
        </option>

        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SingleSelect;
